
export const DEL_DOC="DEL_DOC";
export const DEL_DOC_SUCCESS="DEL_DOC_SUCCESS";
export const DEL_DOC_FAILURE="DEL_DOC_FAILURE";


export const GET_DOCS = "GET_DOCS";
export const GET_DOCS_SUCCESS = "GET_DOCS_SUCCESS";
export const GET_DOCS_FAIL = "GET_DOCS_FAIL";
